/* @flow */

import React from 'react'
import Cleave from 'cleave.js/dist/cleave-react'
import { AbstractInput } from './input'
import type { InputPropsType, InputStateType } from './input'

export type FormatPropsType = InputPropsType & {
  // https://github.com/nosir/cleave.js/blob/master/doc/options.md
  options: Object,
  decimal?: boolean
}

class Format extends AbstractInput<FormatPropsType, InputStateType> {
  cleaveInstance: Cleave

  get value(): string {
    const { value } = this.props
    return this.formatValue(value)
  }

  formatValue(value: any): string {
    return value || ''
  }

  getValue = (event: SyntheticInputEvent<any>): void => {
    const value = this.normalizeValue(event.target.value)
    if (value !== undefined) this.handleChange(value)
  }

  normalizeValue(value: string): any {
    return value
  }

  onCleaveInit = (cleave: Cleave) => {
    this.cleaveInstance = cleave
  }

  componentDidUpdate(prevProps: FormatPropsType) {
    if (prevProps.value != this.props.value) {
      this.cleaveInstance.setRawValue(this.value)
    }
  }

  formField(): React$Element<*> {
    const props = this.getProps()
    return (
      <Cleave
        onInit={this.onCleaveInit}
        options={props.options}
        id={this.id}
        type={props.type || 'text'}
        className={props.inputClassName}
        placeholder={props.placeholder}
        value={this.value}
        onChange={this.getValue}
        onKeyPress={props.onKeyPress}
        onKeyDown={props.onKeyDown}
        onKeyUp={props.onKeyUp}
        onClick={props.onClick}
        name={props.name}
        max={props.max}
        min={props.min}
        pattern={props.pattern}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        disabled={props.disabled}
        readOnly={props.readOnly}
        minLength={props.minLength}
        maxLength={props.maxLength}
        tabIndex={props.tabIndex}
        autoComplete={props.autoComplete}
        autoCorrect={props.autoCorrect}
        autoCapitalize={props.autoCapitalize}
        spellCheck={props.spellCheck}
        ref={this.inputRef}
      />
    )
  }
}

class FormatOnly extends Format {
  render() {
    return this.formField()
  }
}

export { FormatOnly }

export default Format
